import LRadio from './LRadio.vue'

export default (Vue) => {
  Vue.component(LRadio.name, LRadio)
}
